const privadosStore = {
  namespaced: true,
  state: () => ({
    list: [],
    agencias: [],
    agenciasFiltro: [],
    docsVenta: [],
    guias: [],
    idiomas: [],
  }),
  mutations: {
    loadContainers(state, { agencias, agenciasFiltro, docsVenta, idiomas, guias }) {
      state.agencias = agencias;
      state.agenciasFiltro = agenciasFiltro;
      state.docsVenta = docsVenta;
      state.idiomas = idiomas;
      state.guias = guias;
    },
    updateList(state, list) {
      state.list = list;
    },
  },
  getters: {
    hayEditables(state) {
      return state.list.some((item) => item.isNew || item.isEdit);
    },
  },
  actions: {
    newItem({ commit, state }) {
      const newList = [...state.list];

      newList.unshift({
        idPrivado: new Date().getTime(),
        isNew: true,
        isEdit: false,
        tempAgencia: null,
        tempDocVenta: null,
        tempFechaLlegada: "",
        tempFechaSalida: "",
        tempIdioma: "",
        tempPAX: "",
        tempCHD: "",
        tempNroDocVenta: "",
        tempPasajero: "",
      });

      commit("updateList", newList);
    },
    editItem({ commit, state }, id) {
      const newList = state.list.map((item) => {
        if (item.idPrivado == id) {
          return {
            ...item,
            isEdit: true,
            tempAgencia: state.agencias.find((agencia) => agencia.idAgencia == item.idAgencia),
            tempDocVenta: item.idDocVenta ? state.docsVenta.find((docVenta) => docVenta.idDocVenta == item.idDocVenta) : null,
            tempFechaLlegada: item.fechaLlegada,
            tempFechaSalida: item.fechaSalida || "",
            tempIdioma: item.idIdioma ? state.idiomas.find((idioma) => idioma.idIdioma == item.idIdioma) : null,
            tempPAX: item.nroAdultos,
            tempCHD: item.nroNinos || "",
            tempNroDocVenta: item.nroDocVenta || "",
            tempPasajero: item.pasajero,
          };
        }
        return item;
      });

      commit("updateList", newList);
    },
    removeItem({ commit, state }, id) {
      const newList = state.list.filter((item) => item.idPrivado != id);
      commit("updateList", newList);
    },
    saveItem({ commit, state }, id) {
      const newList = state.list.map((item) => {
        if (item.idPrivado == id) {
          return {
            ...item,
            isNew: false,
            isEdit: false,
            agencia: item.tempAgencia.nombre,
            idAgencia: item.tempAgencia.idAgencia,
            docVenta: item.tempDocVenta?.nombre || "",
            idDocVenta: item.tempDocVenta?.idDocVenta || null,
            fechaLlegada: item.tempFechaLlegada,
            fechaSalida: item.tempFechaSalida || "",
            idioma: item.tempIdioma.abreviatura,
            idIdioma: item.tempIdioma.idIdioma,
            nroAdultos: item.tempPAX,
            nroNinos: item.tempCHD || "",
            nroDocVenta: item.tempNroDocVenta || "",
            pasajero: item.tempPasajero,
          };
        }
        return item;
      });

      commit("updateList", newList);
    },
  },
};

export default privadosStore;
